var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLayout',{ref:"userLayout",attrs:{"pageTitle":"Gestione utenti"},scopedSlots:_vm._u([{key:"page-content",fn:function(props){return [_c('FrmManageUsers',{on:{"currentUserChaged":_vm.CurrentUserChanged}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }